// Launch-day run sheet. Times are local to whoever is posting; the kit's launch posts are dated 15 Nov 2026 (Sunday)
// except LinkedIn, which launches Monday 16 Nov when its audience is online.
export const RUN_SHEET = {
  title: "Launch-day run sheet",
  date: "Sunday 15 November 2026",
  intro: "Everything is already written and sized in the kit. This sheet is only about order and timing. Tick as you go; the two reply sweeps matter more than any single post.",
  blocks: [
    {
      t: "Saturday 14 Nov · evening — pre-flight",
      items: [
        { time: "19:00", what: "Settings on /stats: four profile links, tour video, digest email — saved", where: "Stats" },
        { time: "19:10", what: "Tour video uploaded to YouTube as Unlisted; title, description, chapters and thumbnail from the kit", where: "YouTube" },
        { time: "19:20", what: "Teaser #1 (\"Tomorrow.\") posted on all four networks with the 1-day card", where: "All" },
        { time: "19:30", what: "Schedule or pre-write the 09:00 launch posts in each platform's scheduler (do not publish yet)", where: "All" },
        { time: "19:45", what: "Open /stats in a second tab; share preview checked; reply bank open in a third tab", where: "Stats · Kit" },
      ],
    },
    {
      t: "Sunday 15 Nov · morning — go live",
      items: [
        { time: "07:30", what: "Flip the tour video from Unlisted to Public. Pin the first comment (signup link + checklist)", where: "YouTube" },
        { time: "07:35", what: "Confirm the /youtube landing page plays the real video; chapters jump correctly", where: "Site" },
        { time: "08:00", what: "YouTube Community post: \"We're live\" with the launch card", where: "YouTube" },
        { time: "09:00", what: "Facebook launch post (1200×630 card) — pin it to the top of the page", where: "Facebook" },
        { time: "09:05", what: "Instagram launch post (1080² card) + launch Story (1080×1920) with link sticker to the landing page", where: "Instagram" },
        { time: "09:15", what: "Cover photos and bios double-checked on all four pages; link-in-bio points to the landing page with your utm", where: "All" },
        { time: "09:30", what: "Personal shares: founders repost the Facebook and Instagram posts to their own profiles", where: "Personal" },
      ],
    },
    {
      t: "Sunday 15 Nov · daytime — keep it warm",
      items: [
        { time: "11:00", what: "Reply sweep #1 — answer every comment and DM (reply bank: Pricing, Is this for me?)", where: "All" },
        { time: "11:30", what: "Instagram Story: chapter 1 of the tour (0:00–0:20) as a Reel-style clip, \"Drop it in\"", where: "Instagram" },
        { time: "13:00", what: "Facebook: share the tour video natively (upload the file, don't link YouTube) with the tour caption", where: "Facebook" },
        { time: "15:00", what: "Instagram Story: the checklist card with a \"free printable\" link sticker", where: "Instagram" },
        { time: "17:00", what: "Reply sweep #2 — comments, DMs, and thank the people who shared", where: "All" },
        { time: "19:00", what: "Instagram Story: \"Thank you — day one\" with a screenshot of a kind comment (ask permission)", where: "Instagram" },
        { time: "21:00", what: "Check /stats: views and signup clicks by network; note the best-performing post for Monday", where: "Stats" },
      ],
    },
    {
      t: "Monday 16 Nov — professional audience",
      items: [
        { time: "09:00", what: "LinkedIn launch post (advisor angle) — pin to the page; founders share with a personal line", where: "LinkedIn" },
        { time: "09:30", what: "DM the first 10 advisors/attorneys on your list with the partner page link", where: "LinkedIn" },
        { time: "12:00", what: "Reply sweep #3 across all networks", where: "All" },
        { time: "17:00", what: "Review Monday digest preview on /stats; approve any partner applications that came in", where: "Stats" },
      ],
    },
  ],
  footer: "If something slips, keep the order and shift the clock. Order matters (video live before posts link to it); exact minutes don't.",
};
